/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Tokens_Total_BadgeInputs */



/**
* | output |
* | --- |
* | "Total tokens consumed" |
*
* @param {Dashboard_Tokens_Total_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_tokens_total_badge = /** @type {((inputs?: Dashboard_Tokens_Total_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Tokens_Total_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Insgesamt verbrauchte Tokens")
	return /** @type {LocalizedString} */ ("Total tokens consumed")
});